import { createReducer } from '@reduxjs/toolkit';
import { fetchDemoCards } from '../actions/fetchDemoCards';
import { fetchFreeText } from '../actions/fetchFreeText';
import { setDemoViewMode } from '../actions/setDemoViewMode';
import { setDeviceType } from '../actions/setDeviceType';
import { setFreeText } from '../actions/setFreeText';
import { setLocale } from '../actions/setLocale';
import { setAppSessionId } from '../actions/setAppSessionId';
import { IStoreAppState } from '../types/StoreState';

const initialState: any = {}; // initialized during store creation (App/index.tsx)

export const appStateReducer = createReducer<IStoreAppState>(initialState, (builder) =>
  builder
    .addCase(setDeviceType, (state, action) => {
      state.deviceType = action.payload;
    })
    .addCase(setLocale, (state, action) => {
      state.locale = action.payload;
    })
    .addCase(setDemoViewMode, (state, action) => {
      state.demoViewMode = action.payload;
    })
    .addCase(setAppSessionId, (state, action) => {
      state.appSessionId = action.payload;
    })
    .addCase(setFreeText, (state, action) => {
      state.freeText = {
        ...state.freeText,
        ...action.payload,
      };
    })
    .addCase(fetchFreeText.fulfilled, (state, action) => {
      state.freeText = action.payload;
    })
    .addCase(fetchFreeText.rejected, (state, action) => {
      state.freeText = {};
    })
    .addCase(fetchDemoCards.fulfilled, (state, action) => {
      state.demoViewMode = action.payload.demoViewMode;
    }),
);
